//import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { TokenProvider } from './contexts/UserContext';
import Ruta from './app/router';


function App() {
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CssBaseline />
        <TokenProvider>
          <Ruta />
        </TokenProvider>
        {/* {content}*/}
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
